import React from 'react';
import { motion } from 'framer-motion';
import { Calendar, MapPin, ArrowRight, Download, Play } from 'lucide-react';
import { GlassCard } from './GlassCard';
export function UpcomingTraining() {
  return <section className="py-24 relative" data-id="element-319">
      <div className="container mx-auto px-6" data-id="element-320">
        <GlassCard className="p-0 border-white/10 overflow-hidden bg-gradient-to-br from-primary-navy to-background" data-id="element-321">
          <div className="grid lg:grid-cols-2" data-id="element-322">
            <div className="p-12 lg:p-20 space-y-8" data-id="element-323">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-status-success/10 border border-status-success/20 text-status-success text-xs font-bold uppercase tracking-wider" data-id="element-324">
                <span className="relative flex h-2 w-2" data-id="element-325">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-status-success opacity-75" data-id="element-326"></span>
                  <span className="relative inline-flex rounded-full h-2 w-2 bg-status-success" data-id="element-327"></span>
                </span>
                Registration Open
              </div>

              <h2 className="text-4xl md:text-5xl font-bold font-heading text-white leading-tight" data-id="element-328">
                Next Cohort Begins <br data-id="element-329" />
                <span className="text-primary-blue" data-id="element-330">March 7, 2026</span>
              </h2>

              <p className="text-lg text-white/60 leading-relaxed" data-id="element-331">
                Secure your spot in our upcoming Cybersecurity & GRC
                Masterclass. Limited seats available for both online and
                in-person sessions.
              </p>

              <div className="flex flex-col sm:flex-row gap-6" data-id="element-332">
                <div className="flex items-center gap-4" data-id="element-333">
                  <div className="w-12 h-12 rounded-2xl bg-white/5 flex items-center justify-center text-primary-blue border border-white/10" data-id="element-334">
                    <Calendar size={24} data-id="element-335" />
                  </div>
                  <div data-id="element-336">
                    <div className="text-xs text-white/40 uppercase font-bold" data-id="element-337">
                      Duration
                    </div>
                    <div className="text-white font-bold" data-id="element-338">12 Weeks</div>
                  </div>
                </div>
                <div className="flex items-center gap-4" data-id="element-339">
                  <div className="w-12 h-12 rounded-2xl bg-white/5 flex items-center justify-center text-accent-cyan border border-white/10" data-id="element-340">
                    <MapPin size={24} data-id="element-341" />
                  </div>
                  <div data-id="element-342">
                    <div className="text-xs text-white/40 uppercase font-bold" data-id="element-343">
                      Format
                    </div>
                    <div className="text-white font-bold" data-id="element-344">Hybrid / Online</div>
                  </div>
                </div>
              </div>

              <div className="flex flex-wrap gap-4 pt-4" data-id="element-345">
                <button className="px-8 py-4 bg-primary-blue text-white font-bold rounded-full hover:bg-blue-600 transition-all shadow-xl shadow-primary-blue/20 flex items-center gap-2" data-id="element-346">
                  Enroll Today <ArrowRight size={18} data-id="element-347" />
                </button>
                <button className="px-8 py-4 bg-white/5 border border-white/10 text-white font-bold rounded-full hover:bg-white/10 transition-all flex items-center gap-2" data-id="element-348">
                  Download Curriculum <Download size={18} data-id="element-349" />
                </button>
              </div>
            </div>

            <div className="relative hidden lg:block" data-id="element-350">
              <div className="absolute inset-0 bg-gradient-to-l from-primary-blue/20 to-transparent z-10" data-id="element-351" />
              <img src="https://www.cyberreadysecurity.info/wp-content/themes/cyberreadyip212/images/btm3-video.jpg" alt="Training Lab" className="w-full h-full object-cover" data-id="element-352" />

              {/* Floating Stats */}
              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-20" data-id="element-353">
                <motion.div animate={{
                scale: [1, 1.05, 1]
              }} transition={{
                duration: 3,
                repeat: Infinity
              }} className="w-20 h-20 rounded-full bg-primary-blue/90 backdrop-blur-md flex items-center justify-center text-white shadow-2xl cursor-pointer hover:bg-primary-blue transition-colors" data-id="element-354">
                  <Play size={32} fill="currentColor" data-id="element-355" />
                </motion.div>
              </div>
            </div>
          </div>
        </GlassCard>
      </div>
    </section>;
}